import React from "react"
import { Link } from "gatsby"

import logo from "./../../images/logo.png"
import smoothScroll from "../../utils/smooth-scroll"
import withAnalyticsContext from '../../lib/hocs/withAnalyticsContext';

class Navigation extends React.Component {
  state = {
    isActive: false,
  }

  toggleNav = () => {
    this.setState(prevState => ({
      isActive: !prevState.isActive,
    }))
  }

  navigateTo = id => {
    smoothScroll({ id: id, offset: 0 })
    this.toggleNav()
  }

  applyClick = () => {
    this.props.analytics.logEvent('shop_apply_clicked', { button: '1' });
  }
  
  inquiryClick = () => {
    this.props.analytics.logEvent('shop_inquiry_clicked', { button: '1' });
  }

  render() {
    return (
      <nav className="navbar is-fixed-top">
        <div className="container">
          <div className="navbar-brand">
            <a className="navbar-item" href="http://picks.fun/">
              <img src={logo} alt="PICKS" />
            </a>
            <span className="navbar-burger" onClick={this.toggleNav}>
              <span />
              <span />
              <span />
            </span>
          </div>
          <div
            className={
              this.state.isActive ? "navbar-menu is-active" : "navbar-menu"
            }
          >
            <div className="navbar-end">
              <a
                className="navbar-item is-text"
                onClick={e => {
                  this.navigateTo("why-picks")
                }}
              >
                Picksが選ばれる理由
              </a>
              <a
                className="navbar-item is-text"
                onClick={e => {
                  this.navigateTo("how-to-use-picks")
                }}
              >
                Picksの使い方
              </a>
              <div className="navbar-item">
                <a
                  className="button is-size-small is-primary is-fullwidth is-rounded"
                  href="https://start.picks.fun/apply"
                  onClick={this.applyClick}
                >
                  WEB申し込み
                </a>
              </div>
              <div className="navbar-item">
                <a
                  className="button is-size-small is-primary is-fullwidth is-rounded is-outlined"
                  href="https://start.picks.fun/inquiry"
                  onClick={this.inquiryClick}
                >
                  お問い合わせ
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav>
    )
  }
}

export default withAnalyticsContext(Navigation)
